export default __webpack_public_path__ + "media/images/service-image-df83cdb02b3e77f8fbe446005ee47b2f.jpg";